import MuiPagination from './muiPagination'

export default MuiPagination
